import React from 'react';
import { Col, Management, Row } from 'components';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { useManagement } from './useManagement';
import { EditManagementModal } from './edit';

export const SupplierManagement = React.memo(() => {
  const { managementData, openEditManagement, onOpenCloseEditManagement } = useManagement();
  const { hasAccess } = useAccessControl();
  return (
    <Row wrap={false}>
      <Col flex={'566px'}>
        <HasAccess role={PERMISSIONS.suppliers.management.read}>
          <Management
            title={'Management'}
            hasAccessToEdit={hasAccess(PERMISSIONS.suppliers.management.write)}
            onAddModalStateChange={onOpenCloseEditManagement}
            managementData={managementData}
          />
        </HasAccess>
      </Col>
      <EditManagementModal openUpdateModal={openEditManagement} onCancel={onOpenCloseEditManagement} />
    </Row>
  );
});
